import React, { useEffect, useState } from 'react';
import News from '../components/news/News';
import {getYoutubeVideos} from '../hooks/youtube/api';

export default function NewsPage() {

  const [data, setData] = useState([]);

  useEffect(() => {
    getYoutubeVideos().then(
      (result) => { 
          setData(result.items)
      }
    )
  }, [])

  return (
    <div>
      <News videos={data} /> 
    </div>
  )
}
